/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
/* eslint-disable max-depth */
/* eslint-disable prefer-template */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ChatContent } from '../../models/chat.model';

@Component({
    selector: 'app-content-renderer',
    templateUrl: './content-renderer.component.html',
    styleUrls: ['./content-renderer.component.scss'],
    standalone: false
})
export class ContentRendererComponent implements OnChanges, OnDestroy {
    @Input() content!: ChatContent;
    @Input() enableStreaming: boolean = true;
    @Input() enableChatStreaming: boolean = false;
    @Input() streamingSpeed: number = 50; // milliseconds between words
    @Input() isBotMessage: boolean = false; // New input to identify bot messages

    // Streaming properties
    displayedText: string = '';
    isStreaming: boolean = false;
    streamingComplete: boolean = false;
    private streamingTimeout: any;
    private currentWordIndex: number = 0;
    private fullText: string = '';
    private words: string[] = [];

    constructor(private sanitizer: DomSanitizer) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['content'] && this.content) {
            this.initializeStreaming();
        }
    }

    ngOnDestroy(): void {
        this.stopStreaming();
    }

    /**
     * Initialize word-by-word streaming display for bot messages
     */
    private initializeStreaming(): void {
        // Only apply streaming for bot messages, not user messages
        const shouldStream = this.enableStreaming &&
            this.isBotMessage && this.enableChatStreaming &&
            this.content &&
            (this.content.type === 'text' || this.content.type === 'markdown' || this.content.type === 'code');

        if (!shouldStream) {
            this.displayedText = this.getContentText();
            this.streamingComplete = true;
            return;
        }

        this.stopStreaming();
        this.fullText = this.getContentText();
        this.words = this.splitIntoWords(this.fullText);
        this.displayedText = '';
        this.currentWordIndex = 0;
        this.isStreaming = true;
        this.streamingComplete = false;
        this.startStreaming();
    }

    /**
     * Start word-by-word streaming
     */
    private startStreaming(): void {
        if (this.currentWordIndex < this.words.length) {
            // Add space before word (except for the first word)
            if (this.currentWordIndex > 0) {
                this.displayedText += ' ';
            }

            this.displayedText += this.words[this.currentWordIndex];
            this.currentWordIndex++;

            this.streamingTimeout = setTimeout(() => {
                this.startStreaming();
            }, this.streamingSpeed);
        } else {
            this.completeStreaming();
        }
    }

    /**
     * Complete streaming display
     */
    private completeStreaming(): void {
        this.isStreaming = false;
        this.streamingComplete = true;
        this.displayedText = this.fullText;
    }

    /**
     * Stop current streaming process
     */
    private stopStreaming(): void {
        if (this.streamingTimeout) {
            clearTimeout(this.streamingTimeout);
            this.streamingTimeout = null;
        }
        this.isStreaming = false;
    }

    /**
     * Get text content for streaming
     */
    private getContentText(): string {
        if (!this.content) return '';

        switch (this.content.type) {
            case 'text':
            case 'markdown':
                return this.content.data || '';
            case 'code':
                return this.content.data || '';
            default:
                return '';
        }
    }

    /**
     * Split text into words while preserving line breaks and formatting
     */
    private splitIntoWords(text: string): string[] {
        if (!text) return [];

        // Simple word splitting that preserves punctuation with words
        return text.split(/\s+/).filter(word => word.length > 0);
    }

    /**
     * Check if streaming should be applied for current content
     */
    shouldApplyStreaming(): boolean {
        return this.enableStreaming &&
            this.isBotMessage &&
            this.content &&
            (this.content.type === 'text' || this.content.type === 'markdown' || this.content.type === 'code');
    }

    isTableData(data: any): boolean {
        return data && typeof data === 'object' && data.headers && data.rows;
    }

    isListData(data: any): boolean {
        return data && typeof data === 'object' && data.items && Array.isArray(data.items);
    }

    formatText(text: string): string {
        if (!text) return '';

        // Check if text contains HTML table tags
        if (text.includes('<table') && text.includes('</table>')) {
            // Return HTML as-is for tables
            return text;
        }

        const textWithTables = this.convertMarkdownTables(text);

        // Simple markdown-like formatting for regular text
        return textWithTables
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // Bold
            .replace(/\*(.*?)\*/g, '<em>$1</em>') // Italic
            .replace(/`(.*?)`/g, '<code>$1</code>') // Inline code
            .replace(/\n/g, '<br>'); // Line breaks
    }

    private convertMarkdownTables(text: string): string {
        const lines = text.split(/\r?\n/);
        const convertedLines: string[] = [];
        let index = 0;

        while (index < lines.length) {
            if (this.isMarkdownTableStart(lines, index)) {
                const headers = this.parseMarkdownTableRow(lines[index]);
                const rows: string[][] = [];
                index += 2;

                while (index < lines.length && this.isMarkdownTableRow(lines[index])) {
                    rows.push(this.parseMarkdownTableRow(lines[index]));
                    index++;
                }

                convertedLines.push(this.buildMarkdownTableHtml(headers, rows));
                continue;
            }

            convertedLines.push(lines[index]);
            index++;
        }

        return convertedLines.join('\n');
    }

    private isMarkdownTableStart(lines: string[], index: number): boolean {
        if (index + 1 >= lines.length) {
            return false;
        }

        const headerLine = lines[index] || '';
        const separatorLine = lines[index + 1] || '';

        if (!this.isMarkdownTableRow(headerLine)) {
            return false;
        }

        return this.isMarkdownTableSeparator(separatorLine);
    }

    private isMarkdownTableRow(line: string): boolean {
        let isTableRow = false;

        if (line.indexOf('|') > -1) {
            isTableRow = this.parseMarkdownTableRow(line).length > 1;
        }

        return isTableRow;
    }

    private isMarkdownTableSeparator(line: string): boolean {
        const cells = this.parseMarkdownTableRow(line);
        return cells.length > 1 && cells.every(cell => /^:?-{3,}:?$/.test(cell.trim()));
    }

    private parseMarkdownTableRow(line: string): string[] {
        return line
            .trim()
            .replace(/^\|/, '')
            .replace(/\|$/, '')
            .split('|')
            .map(cell => cell.trim());
    }

    private buildMarkdownTableHtml(headers: string[], rows: string[][]): string {
        const numericColumns = headers.map((_, index) =>
            rows.some(row => this.isNumericTableCell(row[index] || ''))
        );
        const headerHtml = headers.map((header, index) => {
            const headerClass = numericColumns[index] ? ' class="chat-markdown-numeric-cell"' : '';
            return '<th' + headerClass + '>' + header + '</th>';
        }).join('');
        const rowsHtml = rows.map(row => {
            const isTotalRow = row[0] && row[0].toLowerCase() === 'total';
            const rowClass = isTotalRow ? ' class="chat-markdown-total-row"' : '';
            const cells = headers.map((_, index) => {
                const cellValue = row[index] || '';
                const cellClass = numericColumns[index] ? ' class="chat-markdown-numeric-cell"' : '';
                return '<td' + cellClass + '>' + cellValue + '</td>';
            }).join('');

            return '<tr' + rowClass + '>' + cells + '</tr>';
        }).join('');

        return '<div class="chat-markdown-table-wrapper"><table class="chat-markdown-table"><thead><tr>' +
            headerHtml +
            '</tr></thead><tbody>' +
            rowsHtml +
            '</tbody></table></div>';
    }

    private isNumericTableCell(value: string): boolean {
        return /^-?\d+(\.\d+)?%?$/.test(value.trim());
    }

    copyToClipboard(text: string): void {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(() => {
                // Could show a toast notification here
                console.log('Copied to clipboard');
            }).catch(err => {
                console.error('Failed to copy: ', err);
            });
        }
    }

    /**
     * Safely sanitize HTML content for rendering
     */
    getSafeHtml(htmlContent: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
    }

    /**
     * Additional methods for table rendering support
     */
    getTableDataSource(): any[] {
        if (!this.isTableData(this.content.data)) return [];

        return this.content.data.rows.map((row: string[]) => {
            const rowObj: any = {};
            this.content.data.headers.forEach((header: string, index: number) => {
                rowObj[`col_${index}`] = row[index] || '';
            });
            return rowObj;
        });
    }

    getTableColumns(): string[] {
        if (!this.isTableData(this.content.data)) return [];

        return this.content.data.headers.map((_: string, index: number) => `col_${index}`);
    }

    getTableAsText(): string {
        if (!this.isTableData(this.content.data)) return '';

        const headerRow = this.content.data.headers.join('\t');
        const dataRows = this.content.data.rows.map((row: string[]) => row.join('\t'));
        return [headerRow, ...dataRows].join('\n');
    }
}